import { render } from "./DashboardLayout.vue?vue&type=template&id=24dbc15e&scoped=true&ts=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=24dbc15e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dbc15e"]])

export default __exports__